
interface NavCategoryProps {
  label: string;
  collapsed: boolean;
}

export const NavCategory = ({ label, collapsed }: NavCategoryProps) => (
  !collapsed ? (
    <div className="px-4 py-2">
      <p className="text-xs uppercase font-medium text-slate-500 tracking-wider">
        {label}
      </p>
    </div>
  ) : null
);
